var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"k-footer navbar navbar-expand-lg"},[_c('a',{staticClass:"navbar-brand mx-auto"})])
}]

export { render, staticRenderFns }